import { modal as actions } from '../actions'
import * as R from 'ramda'

// Reducers for
// store/action-methods/modal.js
export const reducer = {}

reducer[actions.SET_MODAL] = ({ state, action }) =>
  R.mergeRight(state.modal, action.data)
